<template>
    <div>
      <TransactionList/>
    </div>
</template>

<script>
import TransactionList from '../../../components/tax/payments/creditCardPayments/TransactionList.vue';

export default {
  name: 'creditcardpayments',
  data: () => ({

  }),
  components: {
    TransactionList,
  },
};
</script>
